import React from 'react';

import { Button, LbInput, Surface } from '@infoods/lifebase-ui';
import { useFormContext } from 'react-hook-form';
import { useWindowSize } from 'react-use';
import classNames from 'classnames';

import classes from './FiltersRow.module.scss';
import { CoachListFilterFormValues } from '../../../../../../interfaces/coachList/CoachListFilters';

const FiltersRow = () => {
  const { control, reset } = useFormContext<CoachListFilterFormValues>();
  const { width } = useWindowSize();
  const isMobile = width < 768;

  const inputGeneralProps = { control, variant: 'outlined', size: 'small' } as const;

  const handleReset = () => {
    reset();
  };

  const filterClasses = classNames(classes.container, {
    [classes.mobileLayout]: isMobile,
  });

  return (
    <Surface className={filterClasses}>
      <LbInput {...inputGeneralProps} name="coachName" label="Coach Name" />
      <Button variant="outlined" fullWidth size="small" onClick={handleReset}>
        Clear All
      </Button>
    </Surface>
  );
};

export { FiltersRow };
